import styled from 'styled-components'

interface DividerProps {
  maxWidth?: string
  height?: string
  color?: string
}

export const MiddleDivider = ({ maxWidth }: DividerProps) => {
  return <MiddleDividerWrap $maxWidth={maxWidth} />
}

const MiddleDividerWrap = styled.div<{ $maxWidth?: string }>`
  display: flex;
  border-bottom: 15px solid var(--black-6);
  position: relative;
  max-width: ${(props) => props.$maxWidth};
  width: 100%;
`

export const VerticalDivider = ({ height, color }: DividerProps) => {
  return <VerticalDividerWrap $height={height} $color={color} />
}
const VerticalDividerWrap = styled.div<{ $height?: string; $color?: string }>`
  width: 1px;
  background: ${({ $color }) => $color || '#ccc'};
  ${({ $height }) => $height && `height: ${$height}`};
`
